import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { Language } from "../../models/language.model";


export const LanguagesActions = createActionGroup({
  source: 'Languages',
  events: {
    'Add Language': props<{ language: Language }>(),
    'Add Languages': props<{ languages: Language[] }>(),
    'Load Languages': emptyProps(),
    'Remove Language': props<{ languageId: number }>(),
  },
});